export const LANGUAGE_PROFICIENCY_LEVELS = [
  { value: '', label: 'Select level' },
  { value: 'beginner', label: 'Beginner' },
  { value: 'elementary', label: 'Elementary' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced', label: 'Advanced' },
  { value: 'professional', label: 'Professional' },
  { value: 'expert', label: 'Expert' },
  { value: 'native', label: 'Native / Mother tongue' }
];

export const LANGUAGE_LEVEL_LABELS = Object.fromEntries(
  LANGUAGE_PROFICIENCY_LEVELS.filter(o => o.value).map(o => [o.value, o.label])
);

export function emptyLanguageEntry(language) {
  return {
    language,
    read: false,
    write: false,
    speak: false,
    readLevel: '',
    writeLevel: '',
    speakLevel: ''
  };
}
